<ng-http-loader></ng-http-loader>
<div class="pages-body login-page p-d-flex p-flex-column">
    <div class="topbar p-p-1 p-d-flex p-jc-between p-flex-row p-ai-center">
        <div class="topbar-left p-ml-3 p-d-flex" routerLink="/">
            <div class="logo">
                <img src="assets/layout/images/oncc-logo.png" alt=""/>
            </div>
        </div>
        <div class="topbar-right p-mr-3 p-d-flex">
        </div>
    </div>
    <div class="p-as-center p-mt-auto p-mb-auto">
        <p-toast></p-toast>
        <div class="pages-panel card p-d-flex p-flex-column" #loginForm>
            <div class="pages-header p-px-3 p-py-1">
                <h2>LOGIN</h2>
            </div>
            <div class="p-grid">
                <div class="p-md-4">
                    <img height='50%' width='50%' src="assets/layout/images/oncc-logo.png" />
                </div>
                <div class="p-md-4">
                    <h2 style="color:#4CAF50;">SIGO</h2>
                </div>
                <div class="p-md-4">
                    <img src="assets/layout/images/cameroun.png"  />
                </div>
            </div>
            <div class="pages-detail p-mb-6 p-px-6">Please use the form to sign-in SIGO application</div>

            <div class="input-panel p-d-flex p-flex-column p-px-3">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-envelope"></i>
                    </span>
                    <span class="p-float-label">
                        <input type="text"  [(ngModel)]="user.login" name="email" [required]="true" minlength="8" id="email" pInputText>
                        <label for="email">Email</label>
                    </span>
                </div>
                <div class="p-inputgroup p-mt-3 p-mb-6">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-lock"></i>
                    </span>
                    <span class="p-float-label">
                        <input type="password" id="password" name="password"  [required]="true" minlength="8" autocomplete="off" [(ngModel)]="user.password"  pInputText>
                        <label for="password">Password</label>
                    </span>
                </div>
                 
            </div>

            <p-button (click)="login()"  class="login-button p-mb-6 p-px-3" label="LOGIN"></p-button>

        </div>
    </div>
</div>
